module.exports = __webpack_public_path__ + "static/media/00_computer_controlled_toy_car_card.6d496ac6.jpg";